import { CircularProgress, Stack } from "@mui/material";

function LoadingSpinner() {
    return (
        <Stack alignItems="center" justifyContent="center">
            <CircularProgress size="6rem" thickness={2} />
        </Stack>
    );
}

export default LoadingSpinner;
